import { Injectable, inject } from '@angular/core';
import type {
  ServiceAvailabilityRequest,
  ServiceAvailabilityResponse,
} from '../models/service-availability';
import { ShipmentFlowStateService } from '../services/shipment-flow-state.service';
import { AXIOS_INSTANCE } from './api-client.tokens';

@Injectable({ providedIn: 'root' })
export class ServiceAvailabilityApiService {
  private readonly http = inject(AXIOS_INSTANCE);
  private readonly shipmentFlowState = inject(ShipmentFlowStateService);

  /**
   * Requests product service availability (PSA) from JWT_sa via service-availability-service.
   * Sends the wizard flow id so a successful response can include JWT_psa.
   */
  check(request: ServiceAvailabilityRequest): Promise<ServiceAvailabilityResponse> {
    const flowId = this.shipmentFlowState.ensureFlowId();

    return this.http
      .post<ServiceAvailabilityResponse>('/service-availability/check', request, {
        headers: { 'x-flow-id': flowId },
      })
      .then((response) => response.data);
  }
}
